namespace RedBullMOBILE360.Administration {
    export class RoleColumns {
        static columnsKey = 'Administration.Role';
    }
}
